import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Badge,
  Card,
  CardFooter,
  CardImg,
  Col,
  Form,
  FormGroup,
  Input,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row } from 'reactstrap';

class Guides extends Component {
  render() {
    return (
      <div className="tab-guides">

        <Row className="mb-4 align-items-center">
          <Col md={8} className="mb-3 mb-md-0">
            <h3 className="mb-md-0 text-center text-md-left">Guides & Brochures</h3>
            <p className="mb-0 text-center text-md-left">Lorem ipsum dolor sit amet consectetur adipiscing elit.</p>
          </Col>

          <Col md={4}>
            <Form>
              <Row form>
                <Col>
                  <FormGroup className="dropdown-toggle mb-0 input-inline">
                    <Input type="select" name="select" id="filterCategory">
                      <option value="">All Content Types</option>
                      <option value="Guide">Guide</option>
                      <option value="Case Study">Case Study</option>
                      <option value="Article">Article</option>
                      <option value="How To">How To</option>
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
            </Form>
          </Col>

        </Row>

        <Row>
          <Col sm={6} md={4} lg={3}>
            <Card className="guide-card" tag={Link} to="/">
              <CardImg top width="100%" src="/images/guide1.jpg" alt="Guide Image" />
              <CardFooter className="py-2">
                <Badge color="primary">CASE STUDY</Badge>
                <h5 className="mt-1 mb-0">Lorem ipsum dolor sit amet consectetur adipiscing</h5>
              </CardFooter>
            </Card>
          </Col>
          <Col sm={6} md={4} lg={3}>
            <Card className="guide-card" tag={Link} to="/">
              <CardImg top width="100%" src="/images/guide2.jpg" alt="Guide Image" />
              <CardFooter className="py-2">
                <Badge color="primary">ARTICLE</Badge>
                <h5 className="mt-1 mb-0">Lorem ipsum dolor sit amet consectetur adipiscing</h5>
              </CardFooter>
            </Card>
          </Col>
          <Col sm={6} md={4} lg={3}>
            <Card className="guide-card" tag={Link} to="/">
              <CardImg top width="100%" src="/images/guide3.jpg" alt="Guide Image" />
              <CardFooter className="py-2">
                <Badge color="primary">E-BOOK</Badge>
                <h5 className="mt-1 mb-0">Lorem ipsum dolor sit amet consectetur adipiscing</h5>
              </CardFooter>
            </Card>
          </Col>
          <Col sm={6} md={4} lg={3}>
            <Card className="guide-card" tag={Link} to="/">
              <CardImg top width="100%" src="/images/guide4.jpg" alt="Guide Image" />
              <CardFooter className="py-2">
                <Badge color="primary">CASE STUDY</Badge>
                <h5 className="mt-1 mb-0">Lorem ipsum dolor sit amet consectetur adipiscing</h5>
              </CardFooter>
            </Card>
          </Col>
          <Col sm={6} md={4} lg={3}>
            <Card className="guide-card" tag={Link} to="/">
              <CardImg top width="100%" src="/images/guide4.jpg" alt="Guide Image" />
              <CardFooter className="py-2">
                <Badge color="primary">ARTICLE</Badge>
                <h5 className="mt-1 mb-0">Lorem ipsum dolor sit amet consectetur adipiscing</h5>
              </CardFooter>
            </Card>
          </Col>
          <Col sm={6} md={4} lg={3}>
            <Card className="guide-card" tag={Link} to="/">
              <CardImg top width="100%" src="/images/guide3.jpg" alt="Guide Image" />
              <CardFooter className="py-2">
                <Badge color="primary">E-BOOK</Badge>
                <h5 className="mt-1 mb-0">Lorem ipsum dolor sit amet consectetur adipiscing</h5>
              </CardFooter>
            </Card>
          </Col>
          <Col sm={6} md={4} lg={3}>
            <Card className="guide-card" tag={Link} to="/">
              <CardImg top width="100%" src="/images/guide1.jpg" alt="Guide Image" />
              <CardFooter className="py-2">
                <Badge color="primary">CASE STUDY</Badge>
                <h5 className="mt-1 mb-0">Lorem ipsum dolor sit amet consectetur adipiscing</h5>
              </CardFooter>
            </Card>
          </Col>
          <Col sm={6} md={4} lg={3}>
            <Card className="guide-card" tag={Link} to="/">
              <CardImg top width="100%" src="/images/guide2.jpg" alt="Guide Image" />
              <CardFooter className="py-2">
                <Badge color="primary">ARTICLE</Badge>
                <h5 className="mt-1 mb-0">Lorem ipsum dolor sit amet consectetur adipiscing</h5>
              </CardFooter>
            </Card>
          </Col>
        </Row>

        <Row className="mt-2 mb-2">
          <Col>
            <Pagination aria-label="Page navigation example">
              <PaginationItem disabled><PaginationLink previous href="#" /></PaginationItem>
              <PaginationItem active><PaginationLink href="#">1</PaginationLink></PaginationItem>
              <PaginationItem><PaginationLink href="#">2</PaginationLink></PaginationItem>
              <PaginationItem><PaginationLink href="#">3</PaginationLink></PaginationItem>
              <PaginationItem><PaginationLink href="#">4</PaginationLink></PaginationItem>
              <PaginationItem><PaginationLink next href="#" /></PaginationItem>
            </Pagination>
          </Col>
        </Row>

      </div>
    )
  }
}

export default Guides;
